<template>
    <div class="navigation__wrap">
        <div id="navigation" class="navigation__container">
            <div
                v-if="$store.state.config?.modules?.betslip"
                class="navigation__bestslip"
                :class="{ 'navigation__bestslip-open': isOpenBetslip }"
                @click="handleToggleBetslip()"
            >
                <p>
                    {{ getTranslatedText('Betslip') }}
                    <span>{{ renderTotalCart() }}</span>
                </p>
                <button>
                    <img
                        :class="{ 'navigation__bestslip-open': isOpenBetslip }"
                        :src="require(`@/public/img/${$store.state.config.skin}/chevron.svg`)"
                        alt=""
                    />
                </button>
            </div>
            <div class="navigation__content">
                <ul class="navigation__content-list">
                    <li :class="`navigation__content-item home`" @click="navigateMenu('/')">
                        <img :src="require(`@/public/img/${$store.state.config.skin}/nav/home.svg`)" />
                        {{ getTranslatedText('home') }}
                    </li>
                    <template v-for="(v, i) in features" :key="i">
                        <li
                            v-if="!v.isHiddenNav"
                            :class="[
                                'navigation__content-item',
                                v.icon,
                                {
                                    active: routerActive === v.routing && $store.state.config.setup?.isNavActive,
                                },
                            ]"
                            :alt="v.name"
                            @click="navigateMenu(v.routing)"
                        >
                            <template v-if="!isStrEmpty(v.icon) && v?.iconNav">
                                <img v-if="!isStrEmpty(v.icon)" :src="require(`@/public/img/${$store.state.config.skin}/nav/${v.icon}.svg`)" />
                            </template>
                            <template v-else-if="!isStrEmpty(v.icon)">
                                <img v-if="!isStrEmpty(v.icon)" :src="require(`@/public/img/${$store.state.config.skin}/${v.icon}.png`)" />
                            </template>
                            {{ getTranslatedText(v.name) }}
                        </li>
                    </template>
                </ul>
            </div>
            <Betslip v-if="isOpenBetslip" @close-cart="handleToggleBetslip" @continue-paying="handleContinuePaying" />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

import languageMixins from '@/mixins/language-mixins';
import utilsMixin from '@/mixins/function-utils';

import Betslip from '@/components/betslip/index.vue';

export default {
    mixins: [languageMixins, utilsMixin],
    components: { Betslip },
    data() {
        return {
            isOpenBetslip: false,
            routerActive: '',
            features: [],
            dataCart: {
                cart: [],
                quantity: 0,
                transact: [],
                totalCart: 0,
            },
        };
    },
    watch: {
        $route(to) {
            this.routerActive = to.path;
            if(this.isOpenBetslip) {
                this.handleToggleBetslip()
            }
        },
    },
    computed: {
        ...mapState(['ModulesDailyLotto', 'ModulesInstantLotto']),
    },
    created() {
        this.fetdata();
        this.routerActive = this.$route.path;
    },
    methods: {
        fetdata() {
            const { config } = this.$store.state;
            let data = [...config?.features];
            data.sort((a, b) => a?.navOrder - b?.navOrder);

            this.features = data;
        },

        navigateMenu(url) {
            const query = this.$route.query;

            this.$router.push({ path: url, query });
            this.isOpenBetslip = false;
            parent.postMessage({ command: 'is-show-cammera', param: false }, '*');
        },
        handleToggleBetslip() {
            const isOpenBetslip = !this.isOpenBetslip;
            if (isOpenBetslip) {
                document.body.style.overflow = 'hidden';
                window.scrollTo(0, 0);
            } else {
                document.body.style.overflow = 'auto';
            }
            this.isOpenBetslip = isOpenBetslip;
        },
        handleContinuePaying() {
            this.isOpenBetslip = false;
            const query = this.$route.query;
            document.body.style.overflow = 'auto';
            this.$router.push({ path: '/', query });
        },

        renderTotalCart() {
            const { cart, betSlip } = this.$store.state;
            let total = 0;

            if (betSlip.okapiLottery) {
                total += cart.quantity;
            }

            if (betSlip.dailyLotto) {
                total += this.ModulesDailyLotto.totalDaily;
            }

            if (betSlip.instantLotto) {
                total += this.ModulesInstantLotto.totalInstant;
            }

            return total;
        },
    },
};
</script>

<style lang="scss">
@import '@/public/scss/navigation/navigation.scss';
</style>
